<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-custom">
        <div class="card-body p-0">
          <div>
            <b-tabs v-model="tabIndex" content-class="mt-3">
              <b-tab active title="Business Info">
                <div class="my-10 px-8 my-lg-15 px-lg-10">
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <b-form-group
                        label="Display Name"
                        label-for="DisplayName"
                      >
                        <b-form-input
                          v-model="$v.form.DisplayName.$model"
                          :state="validateState('DisplayName')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="DisplayName"
                          placeholder="Display Name"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Display Name is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                      <b-form-group label="ShortName" label-for="ShortName">
                        <b-form-input
                          v-model="$v.form.ShortName.$model"
                          v-mask="'XX'"
                          :state="validateState('ShortName')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="ShortName"
                          placeholder="Prefix"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Prefix is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                  <b-form-group label="Taxpayer Classification">
                    <b-form-radio-group
                      v-model="$v.form.Classification.$model"
                      :options="options.classifications"
                      :state="validateState('Classification')"
                      name="radio-options-Classification"
                    ></b-form-radio-group>
                    <b-form-invalid-feedback>
                      Taxpayer Classification is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <b-form-group label="TIN" label-for="TIN">
                        <b-form-input
                          v-model="$v.form.TIN.$model"
                          v-mask="'###-###-###'"
                          :state="validateState('TIN')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="TIN"
                          placeholder="TIN"
                          readonly
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          TIN is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                      <b-form-group label="Branch Code" label-for="BranchCode">
                        <b-form-input
                          v-model="$v.form.BranchCode.$model"
                          v-mask="'#####'"
                          :state="validateState('BranchCode')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="BranchCode"
                          placeholder="Branch Code"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Branch Code is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <b-form-group
                        label="Revenue District Office"
                        label-for="RDO"
                      >
                        <b-form-select
                          v-model="$v.form.RDO.$model"
                          :options="options.rdo"
                          :state="validateState('RDO')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="RDO"
                          placeholder="Revenue District Office"
                          size="sm"
                        ></b-form-select>
                        <b-form-invalid-feedback>
                          Revenue District Office is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                      <b-form-group label="Tax Type">
                        <b-form-radio-group
                          v-model="$v.form.TaxType.$model"
                          :options="options.taxtypes"
                          :state="validateState('TaxType')"
                          name="radio-options-TaxType"
                        ></b-form-radio-group>
                        <b-form-invalid-feedback>
                          Tax Type is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                  <b-form-group
                    label="Registered Name"
                    label-for="RegisteredName"
                  >
                    <!--                    <b-form-checkbox id="chkRegisteredName" v-model="form.registerednamesameasbusinessname" name="chkRegisteredName" @change="onChangeSameRegisteredName">-->
                    <!--                      Same as business name-->
                    <!--                    </b-form-checkbox>-->
                    <b-form-input
                      v-model="$v.form.RegisteredName.$model"
                      :state="validateState('RegisteredName')"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="RegisteredName"
                      placeholder="Registered Name"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Registered Name is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Business Name" label-for="BusinessName">
                    <b-form-input
                      v-model="$v.form.BusinessName.$model"
                      :state="validateState('BusinessName')"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="BusinessName"
                      placeholder="Business Name"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Business Name is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <div v-if="form.Classification === 'individual'" class="row">
                    <div class="col-12 col-md-4">
                      <b-form-group
                        label="First Name"
                        label-for="BusinessFirstName"
                      >
                        <b-form-input
                          v-model="$v.form.BusinessFirstName.$model"
                          :state="validateState('BusinessFirstName')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="BusinessFirstName"
                          placeholder="First Name"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          First Name is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <b-form-group
                        label="Middle Name"
                        label-for="BusinessMiddleName"
                      >
                        <b-form-input
                          v-model="$v.form.BusinessMiddleName.$model"
                          :state="validateState('BusinessMiddleName')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="BusinessMiddleName"
                          placeholder="Middle Name"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Middle Name is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <b-form-group
                        label="Last Name"
                        label-for="BusinessLastName"
                      >
                        <b-form-input
                          v-model="$v.form.BusinessLastName.$model"
                          :state="validateState('BusinessLastName')"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="BusinessLastName"
                          placeholder="Last Name"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Last Name is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                  <b-form-group
                      :label="($v.form.Classification.$model== 'individual')? 'Date of birth' : 'Date of Incorporation'"
                      label-for="DateOfIncorporation"
                    >
                    <b-input-group>
                      <b-form-input
                        v-model="$v.form.DateOfIncorporation.$model"
                        :state="validateState('DateOfIncorporation')"
                        name="DateOfIncorporation"
                        type="text"
                        autocomplete="off"
                        v-mask="'####-##-##'"
                        class="form-control form-control-solid h-auto py-3 px-3"
                        placeholder="YYYY-MM-DD"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="$v.form.DateOfIncorporation.$model"
                          :state="validateState('DateOfIncorporation')"
                          class="button-only-datepicker"
                          name="DateOfIncorporation"
                          size="sm"
                          button-only
                          right
                          locale="en-US"
                        ></b-form-datepicker>
                      </b-input-group-append>
                      <b-form-invalid-feedback>
                        {{($v.form.Classification.$model== 'individual')? 'Date of birth' : 'Date of Incorporation'}} is required.
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group
                    label="Line of Business"
                    label-for="LineOfBusiness"
                  >
                    <b-form-input
                      v-model="$v.form.LineOfBusiness.$model"
                      :state="validateState('LineOfBusiness')"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="LineOfBusiness"
                      placeholder="Line of Business"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Line of Business Office is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    label="Business Address"
                    label-for="BusinessAddress"
                  >
                    <b-form-input
                      v-model="$v.form.BusinessAddress.$model"
                      :state="validateState('BusinessAddress')"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="BusinessAddress"
                      placeholder="Business Address"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Business Address is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </b-tab>

              <b-tab title="ATG">
                <div class="my-10 px-8 my-lg-15 px-lg-10">
                  <div class="row">
                      <div class="col-12">
                        <b-form-group label="ATG ID" label-for="atgid">
                          <b-form-input
                            v-model="$v.form.ATG.ATGId.$model"
                            :state="validateState('ATGId', $v.form.ATG)"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="ATG ID"
                            placeholder="ATG ID"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            ATG ID is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <b-form-group label="ATG Key" label-for="atgkey">
                          <b-form-input
                            v-model="$v.form.ATG.ATGKey.$model"
                            :state="validateState('ATGKey', $v.form.ATG)"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="atgkey"
                            placeholder="ATG Key"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            ATG Key is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                </div>
              </b-tab>

              <b-tab title="Authorized User">
                <div class="my-10 px-8 my-lg-15 px-lg-10">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <b-form-group label="First Name" label-for="FirstName">
                        <b-form-input
                          v-model="$v.form.AuthorizedUser.FirstName.$model"
                          :state="
                            validateState('FirstName', $v.form.AuthorizedUser)
                          "
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="FirstName"
                          placeholder="First Name"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          First Name is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <b-form-group label="Middle Name" label-for="MiddleName">
                        <b-form-input
                          v-model="$v.form.AuthorizedUser.MiddleName.$model"
                          :state="
                            validateState('MiddleName', $v.form.AuthorizedUser)
                          "
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="MiddleName"
                          placeholder="Middle Name"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Middle Name is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <b-form-group label="Last Name" label-for="LastName">
                        <b-form-input
                          v-model="$v.form.AuthorizedUser.LastName.$model"
                          :state="
                            validateState('LastName', $v.form.AuthorizedUser)
                          "
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="LastName"
                          placeholder="Last Name"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Last Name is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <b-form-group
                        label="Email Address"
                        label-for="EmailAddress"
                      >
                        <b-form-input
                          v-model="$v.form.AuthorizedUser.EmailAddress.$model"
                          :state="
                            validateState(
                              'EmailAddress',
                              $v.form.AuthorizedUser
                            )
                          "
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="EmailAddress"
                          placeholder="Email Address"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Email is required and a valid email address.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <b-form-group
                        label="Mobile Number"
                        label-for="MobileNumber"
                      >
                        <b-form-input
                          v-model="$v.form.AuthorizedUser.MobileNumber.$model"
                          v-mask="'####-###-####'"
                          :state="
                            validateState(
                              'MobileNumber',
                              $v.form.AuthorizedUser
                            )
                          "
                          class="form-control form-control-solid h-auto py-3 px-3"
                          name="MobileNumber"
                          placeholder="Mobile Number"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Mobile Number is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-md-4">
                      <b-form-group
                        label="Landline (Optional)"
                        label-for="Landline"
                      >
                        <b-form-input
                          v-model="$v.form.AuthorizedUser.Landline.$model"
                          v-mask="'(##) ####-####'"
                          :state="
                            validateState('Landline', $v.form.AuthorizedUser)
                          "
                          class="form-control form-control-solid h-auto py-3 px-3"
                          masked="false"
                          name="Landline"
                          placeholder="Landline"
                          size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                          Landline is required.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="card-footer">
          <div class="d-flex flex-wrap flex-center">
            <BackButton v-if="tabIndex == 0"></BackButton>
            <button v-if="tabIndex > 0"
              class="btn btn-light-primary mx-4"
              type="button"
              @click="back"
            >
              Back
            </button>
            <button v-if="tabIndex < 2"
              ref="next"
              class="btn btn-primary mx-4"
              type="button"
              @click="next"
            >
              Next
            </button>
            <button v-if="tabIndex == 2"
              ref="submit"
              :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
              class="btn btn-primary mx-4"
              type="button"
              @click="submit"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import ApiServiceLibrary from "@/core/services/api.service.library";
import BackButton from "@/view/content/widgets/backbutton.vue";
import ApiService from "@/view/pages/easyreceipt/api";

import { validationMixin } from "vuelidate";
import { maxLength, required, requiredIf } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";

export default {
  mixins: [validationMixin],
  name: "topup-transactions-create",
  components: { BackButton },
  directives: { mask },
  props: ["propdata"],
  data() {
    return {
      isBusy: false, //isNew: false,
      tabIndex: 0,
      form: {
        ProfileId: "",
        ShortName: "",
        DisplayName: "",
        Classification: "",
        TIN: "",
        BranchCode: "",
        RDO: "",
        TaxType: "",
        BusinessName: "",
        registerednamesameasbusinessname: false,
        RegisteredName: "",
        BusinessFirstName: "",
        BusinessMiddleName: "",
        BusinessLastName: "",
        DateOfIncorporation: "",
        LineOfBusiness: "",
        BusinessAddress: "",
        IsPrimary: true,
        ATG : {
          ATGId: "",
          ATGKey: "",
        },
        AuthorizedUser: {
          FirstName: "",
          MiddleName: "",
          LastName: "",
          EmailAddress: "",
          MobileNumber: "",
          Landline: ""
        }
      },
      options: {
        classifications: [
          {
            text: "Individual",
            value: "individual"
          },
          {
            text: "Non-Individual",
            value: "non-individual"
          }
        ],
        taxtypes: [
          {
            text: "VAT",
            value: "VAT"
          },
          {
            text: "Non-VAT",
            value: "non-vat"
          }
        ],
        rdo: [
          {
            value: "001",
            text: "001 - LAOAG CITY"
          },
          {
            value: "002",
            text: "002 - VIGAN, ILOCOS SUR"
          },
          {
            value: "003",
            text: "003 - SAN FERNANDO, LA UNION"
          },
          {
            value: "004",
            text: "004 - CALASIAO, WEST PANGASINAN"
          },
          {
            value: "005",
            text: "005 - ALAMINOS, WEST PANGASINAN"
          },
          {
            value: "006",
            text: "006 - URDANETA, EAST PANGASINAN"
          },
          {
            value: "007",
            text: "007 - BANGUED, ABRA"
          },
          {
            value: "008",
            text: "008 - BAGUIO CITY"
          },
          {
            value: "009",
            text: "009 - LA TRINIDAD, BENGUET"
          },
          {
            value: "010",
            text: "010 - BONTOC, MT. PROVINCE"
          },
          {
            value: "011",
            text: "011 - TABUK, KALINGA APAYAO"
          },
          {
            value: "012",
            text: "012 - LAGAWE, IFUGAO"
          },
          {
            value: "013",
            text: "013 - TUGUEGARAO, CAGAYAN"
          },
          {
            value: "014",
            text: "014 - BAYOMBONG, NUEVA VIZCAYA"
          },
          {
            value: "015",
            text: "015 - NAGUILIAN, ISABELA"
          },
          {
            value: "016",
            text: "016 - CABARROGUIS, QUIRINO"
          },
          {
            value: "17A",
            text: "17A - TARLAC CITY"
          },
          {
            value: "17B",
            text: "17B - PANIQUI, TARLAC"
          },
          {
            value: "018",
            text: "018 - OLONGAPO"
          },
          {
            value: "019",
            text: "019 - SUBIC"
          },
          {
            value: "020",
            text: "020 - BALANGA, BATAAN"
          },
          {
            value: "21A",
            text: "21A - NORTH PAMPANGA"
          },
          {
            value: "21B",
            text: "21B - SOUTH PAMPANGA"
          },
          {
            value: "21C",
            text: "21C - CLARK FREEPORT ZONE"
          },
          {
            value: "022",
            text: "022 - BALER, AURORA"
          },
          {
            value: "23A",
            text: "23A - NORTH NUEVA ECIJA"
          },
          {
            value: "23B",
            text: "23B - SOUTH NUEVA ECIJA"
          },
          {
            value: "024",
            text: "024 - VALENZUELA"
          },
          {
            value: "25A",
            text: "25A - PLARIDEL, BULACAN"
          },
          {
            value: "25B",
            text: "25B - STA. MARIA, BULACAN"
          },
          {
            value: "026",
            text: "026 - MALABON - NAVOTAS"
          },
          {
            value: "027",
            text: "027 - KALOOKAN CITY"
          },
          {
            value: "028",
            text: "028 - NOVALICHES"
          },
          {
            value: "029",
            text: "029 - SAN NICOLAS, TONDO"
          },
          {
            value: "030",
            text: "030 - BINONDO"
          },
          {
            value: "031",
            text: "031 - STA. CRUZ"
          },
          {
            value: "032",
            text: "032 - QUIAPO-SAMPALOC-SAN MIGUEL"
          },
          {
            value: "033",
            text: "033 - INTRAMUROS-ERMITA-MALATE"
          },
          {
            value: "034",
            text: "034 - PACO-PANDACAN-STA. ANA"
          },
          {
            value: "035",
            text: "035 - ROMBLON"
          },
          {
            value: "036",
            text: "036 - PUERTO PRINCESA"
          },
          {
            value: "037",
            text: "037 - SAN JOSE, OCCIDENTAL MINDORO"
          },
          {
            value: "038",
            text: "038 - NORTH-QUEZON CITY"
          },
          {
            value: "039",
            text: "039 - SOUTH-QUEZON CITY"
          },
          {
            value: "040",
            text: "040 - CUBAO"
          },
          {
            value: "041",
            text: "041 - MANDALUYONG"
          },
          {
            value: "042",
            text: "042 - SAN JUAN"
          },
          {
            value: "043",
            text: "043 - PASIG CITY"
          },
          {
            value: "044",
            text: "044 - TAGUIG-PATEROS"
          },
          {
            value: "045",
            text: "045 - MARIKINA"
          },
          {
            value: "046",
            text: "046 - CAINTA-TAYTAY"
          },
          {
            value: "047",
            text: "047 - EAST MAKATI "
          },
          {
            value: "048",
            text: "048 - WEST MAKATI"
          },
          {
            value: "049",
            text: "049 - NORTH-MAKATI"
          },
          {
            value: "050",
            text: "050 - SOUTH-MAKATI"
          },
          {
            value: "051",
            text: "051 - PASAY"
          },
          {
            value: "052",
            text: "052 - PARAÑAQUE"
          },
          {
            value: "53A",
            text: "53A - LAS PIÑAS CITY"
          },
          {
            value: "53B",
            text: "53B - MUNTINLUPA CITY"
          },
          {
            value: "54A",
            text: "54A - EAST CAVITE"
          },
          {
            value: "54B",
            text: "54B - WEST CAVITE"
          },
          {
            value: "055",
            text: "055 - EAST LAGUNA"
          },
          {
            value: "056",
            text: "056 - CENTRAL LAGUNA"
          },
          {
            value: "057",
            text: "057 - WEST LAGUNA"
          },
          {
            value: "058",
            text: "058 - BATANGAS CITY"
          },
          {
            value: "059",
            text: "059 - EAST BATANGAS"
          },
          {
            value: "060",
            text: "060 - NORTH QUEZON"
          },
          {
            value: "061",
            text: "061 - SOUTH QUEZON"
          },
          {
            value: "062",
            text: "062 - MARINDUQUE"
          },
          {
            value: "063",
            text: "063 - CALAPAN, ORIENTAL MINDORO"
          },
          {
            value: "064",
            text: "064 - DAET, CAMARINES NORTE"
          },
          {
            value: "065",
            text: "065 - NAGA CITY"
          },
          {
            value: "066",
            text: "066 - IRIGA CITY"
          },
          {
            value: "067",
            text: "067 - LEGASPI CITY"
          },
          {
            value: "068",
            text: "068 - SORSOGON, SORSOGON"
          },
          {
            value: "069",
            text: "069 - VIRAC, CATANDUANES"
          },
          {
            value: "070",
            text: "070 - MASBATE, MASBATE"
          },
          {
            value: "071",
            text: "071 - KALIBO, AKLAN"
          },
          {
            value: "072",
            text: "072 - ROXAS CITY"
          },
          {
            value: "073",
            text: "073 - SAN JOSE, ANTIQUE"
          },
          {
            value: "074",
            text: "074 - ILOILO CITY"
          },
          {
            value: "075",
            text: "075 - ZARRRAGA, ILOILO"
          },
          {
            value: "076",
            text: "076 - VICTORIAS, NEGROS OCCIDENTAL"
          },
          {
            value: "077",
            text: "077 - BACOLOD CITY"
          },
          {
            value: "078",
            text: "078 - BINALBAGAN, NEGROS OCCIDENTAL"
          },
          {
            value: "079",
            text: "079 - DUMAGUETE CITY"
          },
          {
            value: "080",
            text: "080 - MANDAUE CITY"
          },
          {
            value: "081",
            text: "081 - CEBU CITY, NORTH"
          },
          {
            value: "082",
            text: "082 - CEBU CITY, SOUTH"
          },
          {
            value: "083",
            text: "083 - TALISAY, CEBU"
          },
          {
            value: "084",
            text: "084 - TAGBILARAN CITY"
          },
          {
            value: "085",
            text: "085 - CATARMAN, NORTHERN SAMAR"
          },
          {
            value: "086",
            text: "086 - BORONGAN, EASTERN SAMAR"
          },
          {
            value: "087",
            text: "087 - CATBALOGAN, WESTERN SAMAR"
          },
          {
            value: "088",
            text: "088 - TACLOBAN CITY"
          },
          {
            value: "089",
            text: "089 - ORMOC CITY"
          },
          {
            value: "090",
            text: "090 - MAASIN, SOUTHERN LEYTE"
          },
          {
            value: "091",
            text: "091 - DIPOLOG CITY"
          },
          {
            value: "092",
            text: "092 - PAGADIAN CITY"
          },
          {
            value: "93A",
            text: "93A - ZAMBOANGA CITY"
          },
          {
            value: "93B",
            text: "93B - ZAMBOANGA SIBUGAY"
          },
          {
            value: "094",
            text: "094 - ISABELA, BASILAN"
          },
          {
            value: "095",
            text: "095 - JOLO, SULU"
          },
          {
            value: "096",
            text: "096 - BONGAO, TAWI-TAWI"
          },
          {
            value: "097",
            text: "097 - GINGOOG CITY"
          },
          {
            value: "098",
            text: "098 - CAGAYAN DE ORO CITY"
          },
          {
            value: "099",
            text: "099 - MALAYBALAY, BUKIDNON"
          },
          {
            value: "100",
            text: "100 - OZAMIS CITY"
          },
          {
            value: "101",
            text: "101 - ILIGAN CITY"
          },
          {
            value: "102",
            text: "102 - MARAWI CITY"
          },
          {
            value: "103",
            text: "103 - BUTUAN CITY"
          },
          {
            value: "104",
            text: "104 - BAYUGAN, AGUSAN DEL SUR"
          },
          {
            value: "105",
            text: "105 - SURIGAO CITY"
          },
          {
            value: "106",
            text: "106 - TANDAG, SURIGAO DEL SUR"
          },
          {
            value: "107",
            text: "107 - COTABATO CITY"
          },
          {
            value: "108",
            text: "108 - KIDAPAWAN, NORTH COTABATO"
          },
          {
            value: "109",
            text: "109 - TACURONG, SULTAN KUDARAT"
          },
          {
            value: "110",
            text: "110 - GENERAL SANTOS CITY"
          },
          {
            value: "111",
            text: "111 - KORONADAL, SOUTH COTABATO"
          },
          {
            value: "112",
            text: "112 - TAGUM, DAVAO DEL NORTE"
          },
          {
            value: "113",
            text: "113 - WEST DAVAO CITY"
          },
          {
            value: "132",
            text: "132 - EAST DAVAO CITY"
          },
          {
            value: "114",
            text: "114 - MATI, DAVAO ORIENTAL"
          },
          {
            value: "115",
            text: "115 - DIGOS, DAVAO DEL SUR"
          },
          {
            value: "116",
            text: "116 - LTD 116"
          },
          {
            value: "124",
            text: "124 - LTD 124"
          },
          {
            value: "126",
            text: "126 - LTD 126"
          },
          {
            value: "121",
            text: "121 - LTD 121"
          },
          {
            value: "123",
            text: "123 - LTD 123"
          },
          {
            value: "127",
            text: "127 - LTD 127"
          }
        ]
      }
    };
  },
  validations: {
    form: {
      ShortName: { maxLength: maxLength(2) },
      DisplayName: { required },
      Classification: { required },
      TIN: { required },
      BranchCode: { required },
      RDO: { required },
      TaxType: { required },
      BusinessName: { required },
      RegisteredName: { required },
      BusinessFirstName: {
        required: requiredIf(function() {
          return this.form.Classification === "individual";
        })
      },
      BusinessMiddleName: {
        required: requiredIf(function() {
          return this.form.Classification === "individual";
        })
      },
      BusinessLastName: {
        required: requiredIf(function() {
          return this.form.Classification === "individual";
        })
      },
      DateOfIncorporation: { required },
      LineOfBusiness: { required },
      BusinessAddress: { required },
      ATG : {
          ATGId: {},
          ATGKey: {},
      },
      AuthorizedUser: {
        FirstName: { required },
        MiddleName: { required },
        LastName: { required },
        EmailAddress: { required },
        MobileNumber: { required },
        Landline: {}
      }
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    //console.log("clinics-createupdate.mounted");
    //console.log("this.propdata", this.propdata);
    this.init();
  },
  watch: {
    "form.ATG" : {
      immediate : true,
      handler : function(newVal, oldVal){
        if(newVal != oldVal && newVal == null) {
          this.form.ATG = {
            ATGId: "",
            ATGKey: ""
          };
        }
      }
    }
  },
  methods: {
    init() {
      this.setBreadcrumbs("Edit");
      this.resetForm();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "My Business Information",
          route: "/easyreceipt/profile/list"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name, container) {
      //console.log(name, this.$v.form[name]);
      if (container) {
        const { $dirty, $error } = container[name];
        return $dirty ? !$error : null;
      } else {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    resetForm() {
      this.form = this.propdata;
      if (this.form.RegisteredName == "")
        this.form.RegisteredName = this.form.BusinessName;
      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    validateBusinessInfo: function() {
      let retVal = false;
      retVal =
        this.validateState("classification") &&
        this.validateState("tin") &&
        this.validateState("branchcode") &&
        this.validateState("rdo") &&
        this.validateState("businessname") &&
        this.validateState("dateofincorporation") &&
        this.validateState("lineofbusiness") &&
        this.validateState("businessaddress");
      if (this.form.classification === "individual")
        retVal =
          retVal &&
          this.validateState("businessfirstname") &&
          this.validateState("businessmiddlename") &&
          this.validateState("businesslastname");
      else retVal = retVal && this.validateState("registeredname");
      return retVal;
    },
    onChangeSameRegisteredName(checked) {
      this.form.registeredname = checked ? this.form.businessname : "";
    },
    submit: function(e) {
      e.preventDefault();
      this.postRegister();
    },
    next() {
      this.tabIndex++;
    },
    back() {
      this.tabIndex--;
    },
    postRegister() {
      let self = this;
      self.isBusy = true;
      let param = self.form;
      const submitButton = self.$refs["submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.post("business/edit", param)
        .then(({ data }) => {
          if (data) {
            self.isBusy = false;
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            this.$router.push({ name: "easyreceipt-profile" });
          }
        })
        .catch(() => {
          self.isBusy = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    }
  }
};
</script>
